<template>
  <div class="h-full flex items-center justify-center">
    <div class="text-center mb-96">
      <h1 class="text-gray-400 text-9xl font-bold mb-4">404</h1>
      <p class="text-gray-300 text-2xl">Sorry, the chatbot you're looking for does not exist.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: '404',
};
</script>
